import { CompareAnimals } from './compare-animals';

export default CompareAnimals;
